import React, { useEffect, useState } from "react";
import Axios from 'axios'
import { useNavigate } from "react-router-dom";
import { parseJwt } from "../../util/TokenUtill";
import * as ApiEndPoint from '../../shared/api/ApiEndPoint'
import { notification, Spin } from "antd";

export default function LandingPage() {
    const [isLoading, setisLoading] = useState(false);
    const navigate = useNavigate()
    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const code = urlParams.get('code')
        const access_token = sessionStorage.getItem("access_token")
        if (code) {
            console.log('code', code);
            authenticationService(code)
        } else if (access_token) {
            sessionStorage.setItem("refresh_main", "false");
            navigate("/main")
        } else {
            navigate("login")
        }
    }, []);


    async function authenticationService(code) {
        setisLoading(true)
        try {
            const codeVerifier = sessionStorage.getItem('pkce_code_verifier');
            let payload = { 
                "authorization_code": code,
                "code_verifier": codeVerifier
            }
            let result = await (await Axios.post(`${process.env.REACT_APP_API_HOST}/auth/login`, payload)).data
            console.log('result', result)
            if (result.access_token && result.access_token !== '') {
                sessionStorage.setItem("access_token", result.access_token)
                sessionStorage.setItem("refresh_main", "true")
                // sessionStorage.setItem("dev", "test dev")
                const checked = await validateUserProfile(result.access_token);
                if (checked) {
                    navigate('/main')
                } else {
                    sessionStorage.setItem("flx-edit-profile", "true")
                    navigate('/edit-profile')
                }
            } else {
                // access_token is empty - user not from Faculty of Agriculture
                // Clear all session data
                sessionStorage.removeItem("access_token")
                sessionStorage.removeItem("refresh_token")
                sessionStorage.removeItem("refresh_main")
                sessionStorage.removeItem("pkce_code_verifier")
                sessionStorage.removeItem("flx-edit-profile")
                setisLoading(false)
                notification.error({
                    message: `ไม่ได้รับอนุญาต`,
                    description: result.error || `ระบบนี้มีไว้สำหรับบุคลากรและนิสิตของคณะเกษตรเท่านั้น กรุณาติดต่อเจ้าหน้าที่ของหน่วยงานของท่าน`,
                    duration: 0
                })
                setTimeout(() => {
                    navigate(`/login`)
                }, 2000)
            }
        } catch (error) {
            console.log('error', error)
            notification.error({
                message: `Error`,
                description: `${error?.response?.data?.message}`
            })
            navigate(`/login`)
            setisLoading(false)
        }
    }



    async function validateUserProfile(asscessToken) {
        let resultToken = parseJwt(asscessToken)
        let keyCheckStudent = ["Department", "Status", "Phonenumber", "DateOfBirth", "AcademicYear", "ReportTo"]
        let keyCheckProfessor = ["Department"]
        let keyCheckOfficer = ["Phonenumber", "DateOfBirth",]
        let currentAddressCheck = ["City", "HomeNo", "Province", "District", "VillageNo", "Zipcode"]
        let checked = true;
        try {
            let result = await Axios.get(`${process.env.REACT_APP_API_HOST}${ApiEndPoint.USER}/${resultToken?.user_id}`, {
                headers: {
                    'Authorization': `Bearer ${asscessToken}`
                }
            })
            if (result) {
                let userData = result.data
                console.log('userData', userData)
                if (userData.Role === 'STUDENT') {
                    keyCheckStudent.forEach(x => {
                        if (!userData[x] || userData[x] === "") {

                            checked = false
                        }
                    })
                } else if (userData.Role === 'PROFESSOR') {
                    keyCheckProfessor.forEach(x => {
                        if (!userData[x] || userData[x] === "") {
                            console.log(x, '====> false')
                            checked = false
                        }
                    })
                } else if (userData.Role === 'OFFICER') {
                    keyCheckOfficer.forEach(x => {
                        if (!userData[x] || userData[x] === "") {
                            console.log(x, '====> false')
                            checked = false
                        }
                    })
                } else {
                    checked = false
                }

                let userCurrnetAddress = result.data.CurrentAddress;
                currentAddressCheck.forEach(x => {
                    if (!userCurrnetAddress[x] || userCurrnetAddress[x] === "") {
                        console.log(x, '====> false')
                        checked = false
                    }
                })
            }
            return checked;
        } catch (error) {
            console.log('error', error)
            return "Service Error"
        }


    }
    return (
        <div style={{ display: 'flex', width: "100%", height: "100vh", backgroundColor: "#fff", alignItems: "center", justifyContent: "center" }}>
            {isLoading ? <Spin></Spin> : ""}
        </div>
    )
}


